import useCollectedFilters from '../../../trimLevels/hooks/useCollectedFilters';
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import orderOnline from '../../graphql/queries/orderOnline';
import useGetPostCode from '../../../gqlCommon/hooks/useGetPostCode';
import { financeFormInputVar } from '../../../gqlCommon/graphql/cache';
import {
  OrderOnlineExternal,
  OrderOnlineExternalVariables,
} from '../../graphql/queries/__generated__/OrderOnlineExternal';
import useCustomizeCarContext from '../useCustomizeCarContext';

export const useOrderOnline = (configurationSourceUrl: string) => {
  const { selectedCar } = useCustomizeCarContext();
  const isStock = !!selectedCar?.stockInfo;
  const carId = selectedCar?.car.code;
  const { filters } = useCollectedFilters();
  const postCodeValue = useGetPostCode();
  const selectedFeaturesId = selectedCar?.selectedFeatures.selected;
  const financeFormInput = useReactiveVar(financeFormInputVar);

  const [loadOrderOnline, { data, loading, error }] = useLazyQuery<OrderOnlineExternal, OrderOnlineExternalVariables>(
    orderOnline.ORDER_ONLINE,
    {
      variables: {
        selectedCar: {
          id: carId,
          filters,
          selectedFeatureIds: { selected: selectedFeaturesId },
          configurationSourceUrl,
          isStock,
        },
        financeFormInput: financeFormInput,
        postCode: postCodeValue,
      },
    },
  );

  return { data, loading, error, loadOrderOnline };
};

export default useOrderOnline;
